<template><!--  добавить кнопку - "взять точку с карты"-->
  <template v-if="mode === 'table'">
      <div v-if="pointformat(v).lat!=0" class="text-truncate" style="max-width: 300px;">{{pointformat(v).lat}}, {{pointformat(v).lon}}</div> 
  </template>
  <template v-else-if="mode === 'view'">
      <div v-if="pointformat(v).lat!=0" class="text-truncate" style="max-width: 300px;">{{pointformat(v).lat}}, {{pointformat(v).lon}}</div>
  </template>
  <!--template v-else-if="mode === 'mapoint'">
      {{markerLatLng}}
      {{v}}

      <l-map :zoom="4" :center="[67.81105, 34.72061]" style="height: 300px;">
          <l-tile-layer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          layer-type="base"
          name="OpenStreetMap"
          transparent="false"
          ></l-tile-layer>
     
          <l-marker :lat-lng = markerLatLng> </l-marker>

      </l-map>
  </template-->


  <template v-else-if="mode === 'edit'">
    
    <v-dialog v-model="dialogedmap">
          <ol-map
  :loadTilesWhileAnimating="true"
  :loadTilesWhileInteracting="true"
  style="height: 400px"
>
  <ol-view
    ref="view"
    :center="center"
    :rotation="rotation"
    :zoom="zoom"
    :projection="projection"
  />

  <ol-interaction-draw
      v-if="drawEnable"
        :type="drawType"
        @drawend="drawend"
        @drawstart="drawstart"
      >
        <ol-style>
          <ol-style-stroke color="blue" :width="2"></ol-style-stroke>
          <ol-style-fill color="rgba(255, 255, 0, 0.4)"></ol-style-fill>
        </ol-style>
      </ol-interaction-draw>
  <ol-tile-layer>
    <ol-source-xyz :url=this.selected />
  </ol-tile-layer>

  <ol-vector-layer>
    <ol-source-vector>
      <ol-feature>
        <ol-geom-point :coordinates="coordinate"></ol-geom-point>
        <ol-style>
          <ol-style-circle :radius="radius">
            <ol-style-fill :color="fillColor"></ol-style-fill>
            <ol-style-stroke
              :color="strokeColor"
              :width="strokeWidth"
            ></ol-style-stroke>
          </ol-style-circle>
        </ol-style>
      </ol-feature>
    </ol-source-vector>
  </ol-vector-layer>
</ol-map>

<v-card-text class="bg-surface-light">
  <br>
<v-row>
  <v-col>
    <v-text-field label="lat" variant="outlined" v-model=latpoint  @keyup = "validatorlat()" :hint=hintlat>  </v-text-field>
  </v-col>
  <v-col>
    <v-text-field label="lon" variant="outlined" v-model=lonpoint @keyup = "validatorlon()" :hint=hintlat>  </v-text-field>
  </v-col>
  <v-col>
    <v-btn size="x-large" height="56" variant="flat" color="regular" @click="dialogedmap=!dialogedmap">
      <svg-icon size="50px" type="mdi" :path="mdiEarthRemove"/>  <span class="d-none d-sm-none d-md-flex">Hide Map</span>
    </v-btn>
  </v-col>

</v-row>
</v-card-text>
</v-dialog>


    <!-- <v-text-field label="lat" variant="outlined" v-model=latpoint @input="decimalToWktLat(latpoint)">  </v-text-field>
    <v-text-field label="lon" variant="outlined" v-model=lonpoint @input="decimalToWktLon(lonpoint)">  </v-text-field>
    <v-btn size="x-large" @click="dialogedmap=!dialogedmap">Show map</v-btn> -->

      <!-- <v-text-field :label=column.title variant="outlined" v-model=v  @input="handleInput"></v-text-field> -->

      <!-- <v-text-field label="lat" variant="outlined" v-model=latpoint @input="decimalToWkt(latpoint)">  </v-text-field>
      <v-text-field label="lon" variant="outlined" v-model=lonpoint @input:modelValue="decimalToWkt">  </v-text-field> -->
<!-- {{ v }} {{ latpoint }} {{ lonpoint }} -->

<!-- <p class="text-truncate" style="max-width: 300px;">{{pointformat(v).lat}}, {{pointformat(v).lon}}</p> -->
<!-- <br> -->
<!-- <v-form  >  -->
<!-- v-model="v" @submit="handleInput('MULTIPOINT('+34.299503+' '+44.792931+')')"-->

<v-sheet class="d-flex flex-wrap mb-2">
  <v-sheet style="min-width: 110px; max-width: 100%;" class="mr-1">
    <v-text-field :color=colorlat label="lat" variant="outlined" v-model=latpoint  @keyup = "validatorlat()" :hint=hintlat>  </v-text-field>
  </v-sheet>
  <v-sheet style="min-width: 110px; max-width: 100%;" class="mr-1">
    <!-- <v-text-field label="lon" variant="outlined" v-model=lonpoint @input="handleInput()" @keyup = "validator()">  </v-text-field> -->
    <v-text-field :color=colorlon label="lon" variant="outlined" v-model=lonpoint @keyup = "validatorlon()" :hint=hintlat>  </v-text-field>
  </v-sheet>
  <!-- <v-sheet style="min-width: 110px; max-width: 100%;" class="mr-1">
    <v-text-field label="lat" variant="outlined" v-model=latpoint @input="decimalToWktLat(latpoint)">  </v-text-field>
  </v-sheet>
  <v-sheet style="min-width: 110px; max-width: 100%;" class="mr-1">
    <v-text-field label="lon" variant="outlined" v-model=lonpoint @input="decimalToWktLon(lonpoint)">  </v-text-field>
  </v-sheet> -->

    <v-btn size="x-large" height="56" variant="flat" color="regular" @click="dialogedmap=!dialogedmap">
      <svg-icon size="50px" type="mdi" :path="mdiEarth"/>  <span class="d-none d-sm-none d-md-flex">Show Map</span>
    </v-btn>

</v-sheet>



  </template>
  <template v-else>
      {{v}}
  </template>
  
</template>

<script>
//@input="handleInput" 
//import { LMarker, LMap, LTileLayer } from "@vue-leaflet/vue-leaflet";
import MapPointWidgetOl from './MapPointWidgetOl.vue';
import proj4 from 'proj4';
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiEarth, mdiEarthRemove } from '@mdi/js';

export default {
  name: 'point-widget',
  props:['mode','column', 'modelValue'],
  emits: ['update:modelValue'],
  data(){
      return {
        mdiEarth:mdiEarth,
        mdiEarthRemove:mdiEarthRemove,
          v: this.modelValue,
          markerLatLng: '',
          latpoint: '',
          lonpoint: '',

          mapheight: "height: 50%",
 //         pointfieldname: this.column.fieldname,
center: this.pointformatmap(this.modelValue),
projection: "EPSG:3857",
zoom: 8,
rotation: 0,
radius: 10,
strokeWidth: 8,
strokeColor: "#03A9F4",
fillColor: "transparent",
//selected: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
selected: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
coordinate: this.pointformatmap(this.modelValue),
//coordinate: this.pointformatmap(this.v),

drawType: "Point",
drawEnable: true,
meterspoint: '',
getpolygon: '',
wkt: '',
dialogedmap: false,
notnumerror: false,
notnumberlat: false,
notnumberlon: false,
hintlat: '',
hintlon: '',
colorlat: "regular",
colorlon: "regular",


// lat: this.pointformat(this.modelValue).lat,
// lon: '',

      }
  },
  components: {
      MapPointWidgetOl,
      SvgIcon,
      proj4,
/*        LMarker,
  LTileLayer, 
  LMap,  
  */    },

mounted(){
this.v = this.modelValue;
//console.log(this.v);
//  console.log(this.coordinate);
//  console.log(this.modelValue);
if (this.v == null || this.v == ""||this.v == "NULL"){
  this.v = "MULTIPOINT(0 0)";
//    this.v = "MULTIPOINT(0.0 0.0)";


  this.pointformat(this.v);
}
else {
this.pointformat(this.v);
}
//console.log("afount", this.pointformat(this.v));
//  console.log(this.v);
//  console.log(this.coordinate);

  // this.v = 'MULTIPOINT(1 1)';
  // this.pointformat(this.v);

  // console.log(this.modelValue);

  // console.log(this.coordinate);

 },


  methods:{

//     decimalToWkt(){
//       console.log(this.latpoint, this.lonpoint);
//       this.handleInput();
//     },



//       decimalToWktLat(latpointval) {
// //        console.log(latpoint);
// //this.latpoint = Number(latpoint); 
// this.latpoint = latpointval; 
// this.handleInput();
//       },
//       decimalToWktLon(lonpointval) {
// //console.log(lonpoint);
// // if (lonpoint == 0 || lonpoint == '0.' || lonpoint == ''){
// //   lonpoint = 0.0;
// // }
// //lonpoint = Number(lonpoint);
// this.lonpoint = lonpointval; 
// //this.lonpoint = Number(lonpoint); 
// this.handleInput();
//       },

validatorlat(){
  this.notnumberlat = isNaN(Number(this.latpoint));
  if (this.notnumberlat == true){
    this.notnumerror = true;
    this.hintlat = "must contain only digits";
    this.colorlat = "red";
  }
  else {
    this.handleInput();
    this.colorlat = "regular";
    this.hintlat = '';
  }
},


validatorlon(){
  this.notnumberlon = isNaN(Number(this.lonpoint));
  if ( this.notnumberlon == true){
    this.notnumerror = true;
    this.hintlon = "must contain only digits";
    this.colorlon = "red";
  }
  else {
    this.hintlon = '';
    this.handleInput();
    this.colorlon = "regular";
  }
},

      handleInput() {    

        // if (this.lonpoint == 0 || this.lonpoint == 0. || this.lonpoint == 0.0 || this.lonpoint == '' || this.latpoint == 0 || this.latpoint == 0. || this.latpoint == 0.0 || this.latpoint == ''){
        //   this.v = "MULTIPOINT(0.0 0.0)"; 
        //   this.$emit('update:modelValue', "MULTIPOINT(0.0 0.0)");
        //      this.coordinate = this.pointformatmap(this.v);
        // }

        // else {    
        // if (this.lonpoint == 0 || this.lonpoint == 0. || this.lonpoint == 0.0 || this.lonpoint == ''){
        //   this.lonpoint = 0.0;
        // }

        
        //  this.v = ('MULTIPOINT('+this.lonpoint+' '+this.latpoint+')');       
         this.v = 'MULTIPOINT('+Number(this.lonpoint)+' '+Number(this.latpoint)+')';      
         this.$emit('update:modelValue', this.v);

         //if (this.lonpoint == 0 || this.lonpoint == 0. || this.lonpoint == 0.0 || this.lonpoint == '' || this.latpoint == 0 || this.latpoint == 0. || this.latpoint == 0.0 || this.latpoint == ''){
         //  this.v = "MULTIPOINT(0.0 0.0)"
         //}

         this.coordinate = this.pointformatmap(this.v);
        //} 
//console.log(this.coordinate, this.v)
//         this.latpoint = this.pointformat(this.v).lat; // пререрисовка в поле лат
//         this.lonpoint = this.pointformat(this.v).lon; // пререрисовка в поле лон

//           this.$emit('update:modelValue', this.v);
      },

      
        wkt2decimal(val){
          //  var re=/MULTIPOINT\((-?[0-9]*\.?[0-9]*)\s(-?[0-9]*\.?[0-9]*)\)/;
          var re=/MULTIPOINT\(*([0-9]*\.?[0-9]*)\s([0-9]*\.?[0-9]*)\)*/;
          var arr = re.exec(val);	
          if (arr==null || arr.length<3) {
            return {lon:0, lat:0};
          }
          else {
            return {lon:parseFloat(arr[1]), lat:parseFloat(arr[2])};
          }
        },

      
      pointformat(val){
          let point=this.wkt2decimal(val)
//          console.log(point);

this.latpoint = point.lat.toFixed(6).replace(/0+$/, "");
this.lonpoint = point.lon.toFixed(6).replace(/0+$/, "");
// this.latpoint = point.lat;
// this.lonpoint = point.lon;

         return { 
      lat:   point.lat.toFixed(6).replace(/0+$/, ""),
      lon:   point.lon.toFixed(6).replace(/0+$/, ""),
     };

          },

          pointformatmap(v){
              // метод для рисовалки (рисовалку надо бы в отдельный компенент вынести)
          // v -   это произволное локальое значение  - параметр функции, который замещается на необходимое значение в строке markerLatLng: this.pointformat(this.modelValue), (в моделях)

          let point=this.wkt2decimal(v)
        
let lat = Number(point.lat.toFixed(10).replace(/0+$/, ""));
let lon = Number(point.lon.toFixed(10).replace(/0+$/, ""));
//console.log(typeof(lat));
let firstProjection = "EPSG:4326";
let secondProjection = "EPSG:3857";

 //          return proj4(firstProjection,secondProjection,[30,60]);
        return proj4(firstProjection,secondProjection,[lon,lat]);


         //    return [lat,lon];
    //       return [lon, lat];

//            return point.lat.toFixed(6).replace(/0+$/, "")+', '+point.lon.toFixed(6).replace(/0+$/, "");
      },



drawstart(event) {
//console.log(event);
},

drawend(event){
//  console.log(event);
//  console.log(event.target.sketchCoords_[0]);
//  console.log(event.target.sketchCoords_[1]);

let lon = event.target.sketchCoords_[0];
let lat = event.target.sketchCoords_[1];

let firstProjection = "EPSG:3857";
let secondProjection = "EPSG:4326";


let point = proj4(firstProjection,secondProjection,[lon,lat]);

//    console.log(point);

  this.v = ('MULTIPOINT('+point[0]+' '+point[1]+')');            
  this.$emit('update:modelValue', this.v);

//           console.log(this.v);
//           console.log(this.modelValue);

         this.coordinate = this.pointformatmap(this.v);    // перерисовка точки на карте
         this.latpoint = this.pointformat(this.v).lat; // пререрисовка в поле лат
         this.lonpoint = this.pointformat(this.v).lon; // пререрисовка в поле лон

        // this.coordinate = this.pointformatmap(this.modelValue);  
        // так нельзя потому что моделВелью - "меняется" () только для верхнего компонента - менять его значение внутри этого комопнента нельзя - он же пропс!!! 

},



  },

  // watch: {
  //     modelValue() {
  //         this.v = this.modelValue;
  //     }
  // },
//   computed: {
//   // геттер вычисляемого свойства
//   testm() {
//     if (this.lonpoint == 0 || this.lonpoint == 0. || this.lonpoint == 0.0 || this.lonpoint == '' || this.latpoint == 0 || this.latpoint == 0. || this.latpoint == 0.0 || this.latpoint == ''){
//       return "errr"
//     }
//   }
// }

}
</script>
